import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';


 export abstract class BasePolicyClientDO extends BaseDO {
     
    public roleCd:string;
    public clientId:number;
    public clientRefGuid:string;
    public medicalClassCd:string;
    public relationCd:string
    public deDupStatusCd:string;


    // public firstName:string;
    // public genderCd:string;
    // public dateOfBirth:Date=null;
    // public maritalStatusCd:string;
    // public occupationCd:string;
    // public income:number;
    // public education:string;
    // public nationality:string;
    // public email:string;
    // public mobileNum:string;
    // public permanentAddress1:string;
    // public permanentAddress2:string;
    // public  PermanentCity:string;
    // public permanentState:string;
    // public contactAddress1:string;
    // public contactAddress2:string;
    // public relationWithPolicyHolder:string;
    // public modeOfPayment:string;
    // public cardNumber:string;
    // public cardHolderName:string;
    // public branchName:string;
    // public bankName:string;


 }